import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { setSidebar } from '@app/ac'

const mapDispatchToProps = (dispatch) => bindActionCreators({ setSidebar }, dispatch)
export default (component) => connect(null, mapDispatchToProps)(component)
